// @flow

export const CATEGORIES_ENUM = {
  SHARED_RIDE: 'Shared Ride Van',
  PRIVATE_VAN: 'Private Van',
  SEDAN: 'Sedan',
  SUV: 'SUV',
  LIMO: 'Limo',
  PRIVATE_BUS: 'Private Bus',
  AIRPORTER: 'Airporter',
  LOCAL_DRIVER: 'Local Driver',
  TAXI: 'Taxi',
  EXPRESS_TRAIN: 'Express Train',
  MINICAB: 'Minicab',
  MOTOTAXI: 'MotoTaxi',
  SHARED_TAXI: 'Shared Taxi',
  WATER_TAXI: 'Water Taxi',
  SHARED_WATER_TAXI: 'Shared Water Taxi',
  WATER_SHUTTLE: 'Water Shuttle',
  SHARED_WATER_SHUTTLE: 'Shared Water Shuttle',
  HELICOPTER: 'Helicopter',
  BUS: 'Bus',
  ALL_INCLUSIVE_VAN: 'All Inclusive Van',
  ALL_INCLUSIVE_SEDAN: 'All Inclusive Sedan',
  ALL_INCLUSIVE_LOCAL_DRIVER: 'All Inclusive Local Driver',
  ALL_INCLUSIVE_SUV: 'All Inclusive SUV',
  ALL_INCLUSIVE_LIMO: 'All Inclusive Limo',
  ALL_INCLUSIVE_BUS: 'All Inclusive Bus',
  ALL_INCLUSIVE_TAXI: 'All Inclusive Taxi',
  ALL_INCLUSIVE_SHARED_RIDE: 'All Inclusive Shared Van',
  ALL_INCLUSIVE_WATER_TAXI: 'All Inclusive Water Taxi',
  TRAIN: 'Train',
}

export const CATEGORIES_FILTERS = {
  [CATEGORIES_ENUM.SHARED_RIDE]: 'van',
  [CATEGORIES_ENUM.PRIVATE_VAN]: 'van',
  [CATEGORIES_ENUM.ALL_INCLUSIVE_VAN]: 'van',
  [CATEGORIES_ENUM.ALL_INCLUSIVE_SHARED_RIDE]: 'van',
  [CATEGORIES_ENUM.LIMO]: 'limo',
  [CATEGORIES_ENUM.ALL_INCLUSIVE_LIMO]: 'limo',
  [CATEGORIES_ENUM.PRIVATE_BUS]: 'bus',
  [CATEGORIES_ENUM.BUS]: 'bus',
  [CATEGORIES_ENUM.AIRPORTER]: 'bus',
  [CATEGORIES_ENUM.ALL_INCLUSIVE_BUS]: 'bus',
  [CATEGORIES_ENUM.TAXI]: 'taxi',
  [CATEGORIES_ENUM.ALL_INCLUSIVE_TAXI]: 'taxi',
  [CATEGORIES_ENUM.MINICAB]: 'taxi',
  [CATEGORIES_ENUM.SHARED_TAXI]: 'taxi',
  [CATEGORIES_ENUM.EXPRESS_TRAIN]: 'train',
  [CATEGORIES_ENUM.TRAIN]: 'train',
  [CATEGORIES_ENUM.MOTOTAXI]: 'moto',
  [CATEGORIES_ENUM.HELICOPTER]: 'helicopter',
  [CATEGORIES_ENUM.LOCAL_DRIVER]: 'sedan',
  [CATEGORIES_ENUM.ALL_INCLUSIVE_LOCAL_DRIVER]: 'sedan',
  [CATEGORIES_ENUM.SEDAN]: 'sedan',
  [CATEGORIES_ENUM.ALL_INCLUSIVE_SEDAN]: 'sedan',
  [CATEGORIES_ENUM.SUV]: 'suv',
  [CATEGORIES_ENUM.ALL_INCLUSIVE_SUV]: 'suv',
  [CATEGORIES_ENUM.WATER_TAXI]: 'ferry',
  [CATEGORIES_ENUM.SHARED_WATER_TAXI]: 'ferry',
  [CATEGORIES_ENUM.WATER_SHUTTLE]: 'ferry',
  [CATEGORIES_ENUM.SHARED_WATER_SHUTTLE]: 'ferry',
  [CATEGORIES_ENUM.ALL_INCLUSIVE_WATER_TAXI]: 'ferry',
}
